var _filter, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbonOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 76 30",
    width: 76,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 29.6777,
    width: 75.689,
    x: 0.155579,
    y: 0.125
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_5539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_5539",
    mode: "normal",
    result: "shape"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 53,
    x: 11,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.2042.125h-48.5885c-.9532 0-1.7259.603102-1.7259 1.34707v20.87953c0 .744.7727 1.3471 1.7259 1.3471h48.5885c.9531 0 1.7259-.6031 1.7259-1.3471v-20.87953c0-.743968-.7728-1.34707-1.7259-1.34707z",
    fill: "#ff463a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.9746 14.6612 5.7264-9.46925c.1082-.17877.1565-.37591.1406-.57312s-.0956-.3881-.2316-.55493c-.1361-.16684-.3241-.30422-.5466-.39938-.2225-.09517-.4723-.14504-.7262-.14499h-12.0556c-.3164-.00006-.6248.07739-.8815.22138-.2567.14398-.4486.34719-.5486.58082l-6.0278 14.07367c-.051.1195-.077.2446-.0769.3706v5.864c0 .311.1588.6094.4414.8293s.6659.3435 1.0656.3435h18.0834c.2539.0001.5037-.0498.7262-.145s.4105-.2325.5466-.3994c.136-.1668.2157-.3577.2316-.5549s-.0324-.3943-.1406-.5731z",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1412 4.32173c-.1-.23363-.292-.43684-.5487-.58082-.2566-.14399-.565-.22144-.8814-.22138h-12.05568c-.25305.00102-.50171.05162-.723014.14714-.221309.09551-.408147.23286-.543279.39938s-.214207.35684-.22993.5534c-.015723.19657.032413.39305.139967.57133l5.726426 9.46922-5.726426 9.4704c-.107892.1783-.156295.3749-.14074.5716.015556.1968.094569.3873.229741.554.135172.1666.322141.3041.543634.3997.221491.0956.470361.1462.723621.1471h18.08348c.3996 0 .7829-.1236 1.0655-.3435.2827-.2199.4414-.5183.4414-.8293v-5.864c.0001-.126-.0258-.2511-.0768-.3706z",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.2042.125h-48.5885c-.9532 0-1.7259.603102-1.7259 1.34707v20.87953c0 .744.7727 1.3471 1.7259 1.3471h48.5885c.9531 0 1.7259-.6031 1.7259-1.3471v-20.87953c0-.743968-.7728-1.34707-1.7259-1.34707z",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a5a5a5",
    fillOpacity: 0.2,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.2836 12.1614c0 6.0942-4.9403 11.0345-11.0344 11.0345-6.0942 0-11.0345-4.9403-11.0345-11.0345 0-6.09414 4.9403-11.03445 11.0345-11.03445 6.0941 0 11.0344 4.94031 11.0344 11.03445zm-20.0713 0c0 4.991 4.0459 9.0369 9.0369 9.0369 4.9909 0 9.0369-4.0459 9.0369-9.0369 0-4.99092-4.046-9.03688-9.0369-9.03688-4.991 0-9.0369 4.04596-9.0369 9.03688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.8167 12.1631c0 11.9113-9.656 21.5674-21.5673 21.5674-11.9114 0-21.5674-9.6561-21.5674-21.5674 0-11.911349 9.656-21.5674 21.5674-21.5674 11.9113 0 21.5673 9.656051 21.5673 21.5674zm-39.2304 0c0 9.755 7.908 17.663 17.6631 17.663 9.755 0 17.663-7.908 17.663-17.663 0-9.75505-7.908-17.66307-17.663-17.66307-9.7551 0-17.6631 7.90802-17.6631 17.66307z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonOff);
export default __webpack_public_path__ + "static/media/ribbon_off.9b72a7f964e2fd3e773d520d19ad7fc2.svg";
export { ForwardRef as ReactComponent };